module.exports = __webpack_public_path__ + "img/18_16.98b9e44d.png";